import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TsearchPipe } from './tsearch.pipe';



@NgModule({
  declarations: [
    TsearchPipe
  ],
  exports:[
    TsearchPipe
  ],
  imports: [
    CommonModule
  ]
})
export class CustomPipeModule { }
